// Models (Internal)
import { Customer } from '@/api/models/Customer';

// External Libraries
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Interface defining the shape of CustomerState.
 */
export interface CustomerState {
  customers: Customer[] | [];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: CustomerState = {
  customers: [],
  loading: false,
  error: null,
};

// Create a slice
const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    fetchCustomersStart(state, _action: PayloadAction<{ clientId: string }>) {
      state.loading = true;
      state.error = null;
    },
    fetchCustomersSuccess(state, action: PayloadAction<Customer[]>) {
      state.loading = false;
      state.customers = action.payload;
    },
    fetchCustomersFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions
export const { fetchCustomersStart, fetchCustomersSuccess, fetchCustomersFailure } =
  customerSlice.actions;

// Export reducer to be added to the store
export default customerSlice.reducer;
